window.addEventListener('load', function () {
    const target = document.querySelector('.sf-prod-template.sf-product-wrapper');
    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
});



window.addEventListener("scroll", () => {


    const scrollY = window.scrollY;


    const tdiv = document.querySelector(".prod__sticky-atc");
    const scrollTopBtn = document.getElementById("fc-scroll-top");

    // Sticky ATC visibility
    if (tdiv) {
        if (scrollY < 40) {
            tdiv.classList.add("hidden");
        } else {
            tdiv.classList.remove("hidden");
        }
    }

    // Scroll to Top visibility (20% scroll)
    if (scrollTopBtn) {
        const winHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        const totalScrollable = docHeight - winHeight;
        
        if (totalScrollable > 0) {
            const scrollPercent = (scrollY / totalScrollable) * 100;
            if (scrollPercent >= 20) {
                scrollTopBtn.classList.add("show");
            } else {
                scrollTopBtn.classList.remove("show");
            }
        }
    }
}, { passive: true });


async function initFC() {
    /* ====== CONFIG ====== */
    const TZ = 'Asia/Dhaka';
    const WHATSAPP_TEXT = "Hi Fitment Craft, I need help.";

    // API endpoint to check for live agents
    // Replace this with your actual API endpoint
    const LIVE_AGENT_API_URL = 'https://fitmentcraft-chat-agent.vercel.app/api/open'; // Fake API for testing

    const AGENTS = [
        { name: "Saiful", phone: "8801727090875", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Friday"], start: 12, end: 21 },
        //{name:"Tarikul", phone:"8801727090674", days:["Saturday","Sunday","Monday","Tuesday","Wednesday","Friday"], start:9, end:18},
        { name: "Fahim", phone: "8801894420352", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"], start: 12, end: 21 },
        //{ name: "Pinky", phone: "8801897711118", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Friday"], start: 9, end: 18 },
        { name: "Nitu", phone: "8801898205751", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], start: 21, end: 2 },
        { name: "Kawser", phone: "8801898805725", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Friday"], start: 9, end: 18 },
        { name: "Ridi", phone: "8801898805724", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"], start: 9, end: 18 },
        { name: "Koli", phone: "8801894420364", days: ["Saturday", "Sunday", "Monday", "Wednesday", "Thursday", "Friday"], start: 15, end: 0 },
        { name: "Nazmul", phone: "8801894420360", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], start: 8, end: 13 },
        { name: "Pinky", phone: "8801898205750", days: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"], start: 9, end: 18 }
    ];

    /* Check for live agent via API */
    async function getLiveAgent() {
        try {
            const response = await fetch(LIVE_AGENT_API_URL);
            const data = await response.json();

            const withoutDefault = data.filter(item => item.isDefault == false)
            if (data.length > 0) {
                const users = data;

                const liveUsers = users.filter(user => user.isLive);
                const randomTwo = liveUsers.sort(() => 0.5 - Math.random()).slice(0, 2);
                return randomTwo;
            }

            return null;
        } catch (error) {
            console.warn('Error checking live agent:', error);
            return null;
        }
    }

    /* time now (Dhaka) */
    const now = new Date();
    const fmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, weekday: 'long', hour: 'numeric', hour12: false });
    const parts = fmt.formatToParts(now);
    const currentDay = parts.find(p => p.type === 'weekday').value;
    const currentHour = parseInt(parts.find(p => p.type === 'hour').value, 10);

    function isAvailable(a) {
        if (!a.days.includes(currentDay)) return false;
        const s = a.start, e = a.end, h = currentHour;
        if (e > s) return h >= s && h < e;
        return (h >= s && h <= 23) || (h >= 0 && h < e);
    }
    const open = AGENTS.filter(isAvailable);

    function uniqByPhone(list) {
        const seen = new Set(), out = [];
        for (const a of list) { const ph = ('' + a.phone).replace(/[^0-9]/g, ''); if (!seen.has(ph)) { seen.add(ph); out.push(a); } }
        return out;
    }
    const uniqOpen = uniqByPhone(open);

    // Check for live agent first
    const liveAgent = await getLiveAgent();
    let callAgent = null, waAgent = null;

    // If live agent is available, use it
    if (liveAgent && liveAgent.length > 0) {
        const myagent = liveAgent
            .filter(item => !item.isDefault)
            .map(prev => ({ ...prev, phone: "88" + prev.phone }));

        if (myagent.length > 1) {
            callAgent = myagent[0];
            waAgent = myagent[1];
        } else if (myagent.length === 1) {
            callAgent = myagent[0];
            waAgent = myagent[0]; // same single agent used for both
        }
    }

    // Otherwise, use the regular agent selection logic
    else if (uniqOpen.length >= 2) {
        const i1 = Math.floor(Math.random() * uniqOpen.length);
        callAgent = uniqOpen[i1];
        const others = uniqOpen.filter((_, i) => i !== i1);
        waAgent = others[Math.floor(Math.random() * others.length)];
    } else if (uniqOpen.length === 1) {
        callAgent = waAgent = uniqOpen[0];
    } else {
        const support = AGENTS.find(a => (a.name || '').toLowerCase() === 'support');
        const pool = support ? [support, ...AGENTS.filter(a => a !== support)] : [...AGENTS];
        const uniqPool = uniqByPhone(pool);
        if (uniqPool.length >= 2) {
            const i1 = Math.floor(Math.random() * uniqPool.length);
            callAgent = uniqPool[i1];
            const others = uniqPool.filter((_, i) => i !== i1);
            waAgent = others[Math.floor(Math.random() * others.length)];
        } else if (uniqPool.length === 1) {
            callAgent = waAgent = uniqPool[0];
        } else return;
    }

    /* apply to all buttons (floating and popover) */
    const callBtns = document.querySelectorAll('.fc-call');
    const waBtns = document.querySelectorAll('.fc-wa');
    const callDigits = ('' + callAgent.phone).replace(/[^0-9]/g, '');
    const waDigits = ('' + waAgent.phone).replace(/[^0-9]/g, '');

    callBtns.forEach(btn => {
        btn.href = 'tel:+' + callDigits;
        btn.title = 'Call: ' + (callAgent.name || '');
    });

    waBtns.forEach(btn => {
        btn.href = 'https://wa.me/' + waDigits + '?text=' + encodeURIComponent(WHATSAPP_TEXT);
        btn.title = 'WhatsApp: ' + (waAgent.name || '');
    });

    /* toggle floating contact */
    const wrap = document.getElementById('fc-wrap');
    const main = document.getElementById('fc-main');
    if (wrap && main) {
        function closeFC() { wrap.classList.remove('fc-open'); main.setAttribute('aria-expanded', 'false'); }
        function toggleFC(e) { e && e.stopPropagation(); const open = wrap.classList.toggle('fc-open'); main.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        main.addEventListener('click', toggleFC);
        document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) closeFC(); }, { passive: true });
    }

    /* toggle product page popover */
    const pdpMain = document.getElementById('pdp-chat-now');
    const pdpWrap = pdpMain?.closest('.chat-popover-wrap');
    if (pdpMain && pdpWrap) {
        function closePDP() { pdpWrap.classList.remove('open'); pdpMain.setAttribute('aria-expanded', 'false'); }
        function togglePDP(e) { e && e.stopPropagation(); const open = pdpWrap.classList.toggle('open'); pdpMain.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        pdpMain.addEventListener('click', togglePDP);
        document.addEventListener('click', (e) => { if (!pdpWrap.contains(e.target)) closePDP(); }, { passive: true });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            if (wrap) wrap.classList.remove('fc-open');
            if (pdpWrap) pdpWrap.classList.remove('open');
        }
    });

    /* Scroll to Top Click */
    const scrollTopBtn = document.getElementById('fc-scroll-top');
    if (scrollTopBtn) {
        scrollTopBtn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
}

window.addEventListener('load', initFC, { once: true });

console.log("working js k11 - popover added")